import { Component, inject, Input } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { RouterLink } from '@angular/router';
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'app-login-buttons',
    templateUrl: './login-buttons.component.html',
    styleUrls: ['./login-buttons.component.scss'],
    imports: [MaterialModule, RouterLink]
})
export class LoginButtonsComponent {

  @Input()
  showRegister: boolean;

  @Input()
  showLogin: boolean;

  private auth = inject(AuthenticationService);

  logout(): void {
    this.auth.logout();
  }

}
